<template>
  <div
    class="gpt" 
    :class="[chatMessages.length <= 0 ? 'gpt__align-center' : 'gpt__align-start']"
  >
    <h1 style="visibility: hidden;">KazatelGPT</h1>
    <sidebar
      class="gpt__sidebar"
      :limitReady="isInitialized"
      :limitExceeded="limitExceeded"
      :rest="restQueries"
      :limit="limitQueries"
      @clear-chat="clearChat"
      @send-prompt-to-chat="(promt) => { sendMessage(promt, false) }"
    />
    <div class="gpt__main">
      <div class="main__dialog">
        <message-container
          :chatMessages="chatMessages" 
          :loading="loadingMessage" 
          :limit="limitExceeded"
        />
      </div>

      <!-- <limits-container
        v-show="isInitialized"
        :rest="restQueries" 
        :limit="limitQueries"
      /> -->

      <div class="main__input">
        <div v-show="!limitExceeded" class="input-button__wrapper">
          <textarea
            ref="textarea"
            class="textarea textarea_type_gpt"
            v-model="userInput"
            @keyup.enter="sendMessage(userInput)"
            @input="adjustTextareaHeight"
            placeholder="Спросить КазательGPT"
          />
          <kaz-button
            class="button_send"
            :label="''"
            @click="sendMessage(userInput)"
            :disabled="userInput.trim().length === 0"
            :leftIcon="true"
            :leftIconName="'kuiIconArrowRightLarge'"
            :appearance="'flat'"
            :mode="'normal'"
          />
        </div>
        <p
          v-show="!limitExceeded"
          class="label label_size_M"
        >
          КазательGPT может допускать ошибки
        </p>
        <dialog-limit v-show="limitExceeded"/>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import MessageContainer from './components/MessageContainer.vue'
import Substitutions from './components/Substitutions.vue';
import LimitsContainer from './components/LimitsContainer.vue';
import DialogLimit from './components/DialogLimit.vue';
import KazButton from '@/components/KazUI/atoms/button/index.vue'

import useLoadingStates from '@/hooks/loading/useLoadingStates.js';
import useSubscriptions from '@/hooks/billing/useSubscriptions.js';

const { GptClient } = require('@/generated/gpt/gpt_service_grpc_web_pb.js');

import { fetchMethodData } from '@/utils/loaders.js';
import { setRemoteTitleDescription } from '@/utils/seo';


export default {
  name: 'gpt',

  components:{
    Sidebar,
    MessageContainer,
    Substitutions,
    LimitsContainer,
    DialogLimit,
    KazButton
  },

  setup() {
    const { LOADING_STATES } = useLoadingStates();
    const { activeSubscriptions, initSubsInfo } = useSubscriptions();
    return { LOADING_STATES, activeSubscriptions, initSubsInfo }
  },

  data() {
    return {
      userInput: '',
      chatMessages: [],
      serviceURL: process.env.VUE_APP_REGISTRATION_SERVICE_URL,
      gptService: null,
      loadingMessage: false,
      limitExceeded: false,
      restQueries: null,
      limitQueries: null,
      initState: this.LOADING_STATES.INIT,
    };
  },

  computed: {
    isInitialized() {
      return this.initState === this.LOADING_STATES.LOADED
    }
  },

  methods: {
    adjustTextareaHeight() {
      const textarea = this.$refs.textarea;
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    sendMessage(promt, fromInput=true) {
      this.loadingMessage = true;
      if (promt.trim() !== '') {
        try {
          if (this.restQueries) {
            --this.restQueries;
          }
          this.chatMessages.push({ type: 'user', text: promt });
          if (fromInput) {
            this.userInput = '';
          }
          const streamRequest = new proto.kazatel.gpt.CompletionRequest();
          const options = new proto.kazatel.gpt.CompletionOptions();
          options.setStream(false);
          const temperature = new proto.google.protobuf.DoubleValue();
          temperature.setValue(0.6);
          options.setTemperature(temperature);
          const maxTokens = new proto.google.protobuf.Int64Value();
          maxTokens.setValue(2000);
          options.setMaxTokens(maxTokens);
          streamRequest.setCompletionOptions(options);
          let arrayMessages = [];
          for(const key in this.chatMessages){
            const message = new proto.kazatel.gpt.Message();
            message.setRole(this.chatMessages[key].type=="bot" ? "assistant" : this.chatMessages[key].type);
            message.setText(this.chatMessages[key].text);
            arrayMessages.push(message);
          }
          streamRequest.setMessagesList(arrayMessages);

          const tokens = this.$getTokenInfo();
          const metadata = { 'token': tokens.accessToken.token };

          const stream = this.gptService.textGeneration(streamRequest, metadata);
          stream.on('data', this.fetchStreamData);

          localStorage.setItem('chatMessages', JSON.stringify(this.chatMessages));
        } catch (error) {
          console.log(error);
        } finally {
          const textarea = this.$refs.textarea;
          textarea.style.height = 'auto';
        }
      }
    },
    loadChatMessagesFromLocalStorage() {
      const savedMessages = localStorage.getItem('chatMessages');
      if (savedMessages) {
        this.chatMessages = JSON.parse(savedMessages);
      }
    },
    scrollToBottom() {
      // const messagesContainer = this.$refs.messages;
      // messagesContainer.scrollTop = messagesContainer.scrollHeight;
    },
    clearChat() {
      this.chatMessages = [];
      localStorage.removeItem('chatMessages');
    },
    insertText(substitution) {
      const textToInsert = `${substitution.heading} ${substitution.substitude}`;
      if(this.userInput = ''){
        this.userInput += textToInsert;
      } else {
        this.userInput = ''
        this.userInput += textToInsert;
      }
    },
    fetchStreamData(response) {
      try {
        this.extractRestQueries(response);
        const message = response.toObject();
        const formattedText = message.alternativesList[0].message.text.replace(/\n/g, '<br>');
        this.chatMessages.push({
          type: 'bot', 
          text: formattedText
        });
        localStorage.setItem('chatMessages', JSON.stringify(this.chatMessages));
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMessage = false;
      }
    },
    extractRestQueries(response) {
      // Response is raw gRPC object.
      this.limitExceeded = response.getOverLimit();
      console.warn('LLLLLLLLLLLL', response.getOverLimit() )
      this.restQueries = response.getRestQueries();
    },
    async getRestQueries() {
      try {
        const request = new proto.kazatel.gpt.RestGptQueriesResponse();
        const tokens = this.$getTokenInfo();
        const metadata = { 'token': tokens.accessToken.token };
        const res = await fetchMethodData(this.gptService, 'rest', {request, metadata});
        this.extractRestQueries(res);
      } catch (error) {
        console.error('Fetch GPT rest info:', error);
      }
    },
    async getLimitQueries() {
      try {
        await this.initSubsInfo();
        const subKey = Object.keys(this.activeSubscriptions)[0];
        this.limitQueries = this.activeSubscriptions[subKey].gptQueries;
      } catch (error) {
        // In this case probably user has no any subscription
        console.error('Get limit queries ERROR');
        this.limitQueries = 2;
      }
    },
    async initContent() {
      try {
        this.initState = this.LOADING_STATES.LOADING;
        this.gptService = new GptClient(this.serviceURL, null, null);
        await this.getRestQueries();
        await this.getLimitQueries();
      } catch (error) {
        console.error('Init GPT service ERROR');
      } finally {
        this.initState = this.LOADING_STATES.LOADED;
      }
    }
  },

  async created() {
    this.initContent();
    this.loadChatMessagesFromLocalStorage();
    await setRemoteTitleDescription(this, this.$route.path);
  }
};
</script>

<style scoped>
.gpt{
  padding: 0px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  height: 100vh;
  align-items: flex-start;
  position: relative;
  background-color: var(--kaz-base-base-02);
}
.gpt__align-start{
  align-items: flex-start;
}
.gpt__align-center{
  align-items: center;
}

.gpt__main{
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: 100%;
  overflow: hidden;
}
.main__dialog{
  margin: 0 auto;
  width: 768px;
  height: 100%;
  padding: 32px 0px 118px 0px;
  overflow-y: scroll;
  scrollbar-width: none;
}
.main__dialog::-webkit-scrollbar {
  display: none;
}
.main__input {
  position: fixed;
  padding-bottom: 16px;
  bottom: 0;
  width: 768px;
  background-color: var(--kaz-base-base-02);
  z-index: 1;
}
.main__input p{
  text-align: center;
  margin-top: 8px;
  color: var(--kaz-textIcons-text-03);
}
.textarea{
  width: 100%;
  min-height: 72px;
  padding: 16px 100px 12px 12px;
  align-items: center;
  border-radius: 12px;
  border: 1px solid var(--kaz-base-base-04);
  background: var(--kaz-base-base-01);
  color: var(--kaz-textIcons-text-01);
  font-size: var(--kaz-font-size-label-M);
  font-style: normal;
  font-weight: var(--kaz-font-weight-medium);
  line-height: var(--kaz-line-height-label-M);
  letter-spacing: var(--kaz-letter-spacing-label-M);
  resize: none;
  max-height: 120px;
  scrollbar-width: none;
}

.textarea::-webkit-scrollbar {
    display: none;
}

.textarea:focus{
  outline: 2px solid var(--kaz-base-primary);
}

.button_send{
  position: absolute;
  right: 16px;
  bottom: 10px;
}

.input-button__wrapper{
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* @media screen and (max-width: 1140px) {
  .main__dialog{
    width: calc(100% - 32px);
  }

  .main__input{
    width: calc(100% - 32px);
  }
} */

@media screen and (max-width: 992px) {
  .gpt{
    flex-direction: column;
  }
  .gpt__main{
    padding: 0px 16px;
    width: 100%;
    height: 100%;
  }
  .main__dialog{
    margin: 0 auto;
    width: 100%;
    padding: 16px 0px 140px 0px;
    /* overflow-y: scroll; */
  }
  .main__input{
    padding-bottom: 16px;
    position: fixed;
    bottom: 0px;
    z-index: 999;
    width: calc(100% - 32px);
    background-color: var(--kaz-base-base-02);
  }
}
</style>